import { motion } from "framer-motion";
import { fadeUp, LOGO_DIAMOND } from "@/lib/site";

const COLS = [
  {
    n: "01",
    title: "Samo Meta oglasi",
    body:
      "Ne radimo SEO, web dizajn ni vođenje društvenih mreža. Cijeli naš rad, alati i iskustvo usmjereni su na jedan kanal — Facebook i Instagram oglase.",
  },
  {
    n: "02",
    title: "Specijalizacija je prednost",
    body:
      "Agencije koje rade sve, rade sve prosječno. Fokus na jednom kanalu znači da poznajemo svaki detalj koji donosi jeftinije i kvalitetnije upite.",
  },
  {
    n: "03",
    title: "Samo odabrane klinike",
    body:
      "Radimo isključivo s određenim klinikama. Znamo pravila oglašavanja u djelatnosti raznih tretmana na ljudima, jezik klijenata i što stvarno pokreće termin.",
  },
];

export default function WhyMeta() {
  return (
    <section id="usluge" className="relative z-10 bg-[#050505] py-24 md:py-36">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="mb-16 flex items-center gap-3"
        >
          <img src={LOGO_DIAMOND} alt="" className="diamond-bullet" />
          <span className="eyebrow">Naše usluge</span>
        </motion.div>

        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="mb-16 max-w-4xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-white md:text-6xl"
        >
          Zašto <span className="text-[#50C878]">samo</span> Meta oglasi
        </motion.h2>

        <div className="grid grid-cols-1 border-t border-[#222] md:grid-cols-3">
          {COLS.map((c, i) => (
            <motion.div
              key={c.n}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-40px" }}
              custom={i}
              className={`group flex flex-col gap-5 py-10 md:py-14 md:px-10 ${
                i < COLS.length - 1 ? "border-b border-[#222] md:border-b-0 md:border-r" : ""
              } ${i === 0 ? "md:pl-0" : ""}`}
            >
              <span className="font-display text-6xl font-black text-[#1c1c1c] transition-colors duration-500 group-hover:text-[#50C878]/40">
                {c.n}
              </span>
              <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-white">
                {c.title}
              </h3>
              <p className="text-base leading-relaxed text-white/55">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
